import dayjs from 'utils/dayjs';

// 原型 malpracticeWarnText（10/15）：malpractice 证书一过期，所有在途申请都会被 payer 挂起，
// 所以提前 30 天黄色提醒、过期后红色；只提醒不拦截（续保在保险公司那边，不在我们这）。
// Credentialing 页横幅用后端 overview 的 malpracticeAlert；Step 4 / 只读视图要跟着表单里刚改的
// 日期走，只能本地算——阈值与「今天」的口径（美东）和后端保持一致。
export const MALPRACTICE_WARN_DAYS = 30;

export type TMalpracticeExpiry = {
    expired: boolean;
    daysLeft: number;
    text: string;
};

export const malpracticeExpiryText = (expired: boolean, daysLeft: number, expireDate: string) =>
    expired ? `expired on ${expireDate}` : `expires in ${daysLeft} day${daysLeft === 1 ? '' : 's'}`;

// expireDate 兼容表单里的 dayjs 与接口返回的 'YYYY-MM-DD' 字符串；超出 30 天或无值返回 null
export function getMalpracticeExpiry(expireDate: any): TMalpracticeExpiry | null {
    if (!expireDate) return null;
    const exp = dayjs(expireDate);
    if (!exp.isValid()) return null;
    const expDay = exp.format('YYYY-MM-DD');
    const todayEt = dayjs().tz('America/New_York').format('YYYY-MM-DD');
    const daysLeft = dayjs(expDay).diff(dayjs(todayEt), 'day');
    if (daysLeft > MALPRACTICE_WARN_DAYS) return null;
    const expired = daysLeft < 0;
    const text = expired
        ? `Your malpractice certificate ${malpracticeExpiryText(
              true,
              daysLeft,
              expDay,
          )}. Every application still with a payer is on hold until you upload a current one.`
        : `Your malpractice certificate ${malpracticeExpiryText(
              false,
              daysLeft,
              expDay,
          )}. Payers put every open application on hold once it lapses, so upload the renewed certificate as soon as your carrier issues it.`;
    return { expired, daysLeft, text };
}
